<!-- Login page content -->
<div id="loginContainer" class="container-fluid">
  <div id="loginRow" class="row">
    <div id="loginCol" class="col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-8 offset-md-2 selectLang-form">
      <div id="loginLogoImage" class="central_logo"> <img class="img-fluid" alt="IPOS Central LOGO" /> </div>
      <!-- Login Section -->
      <div id="loginCard" class="card language_card">
        <div id="loginCardHeader" class="card-header">
         <span class="language_heading"> <img class="lang_image" alt="select language">&nbsp;
          <h5 [innerHTML]="languageHeading"></h5> </span>
          <p class="ipos_central_p" [innerHTML]="subHeading"></p>
        </div>
        <div id="loginCardBody" class="card-body">
          <form [formGroup]="langForm" class="dropdownscroll" ngbRadioGroup>
            <div id="loginCardBodyRadio" class="card-body">
              <label for="{{ language.langInEng }}" class="lang_radiobtn"
               *ngFor="let language of languageJSON; trackBy: trackByLanguage" >
                {{ language.langName }}
                <input type="radio" name="langRadios" id="{{ language.langName }}" [value]='language.langName'
                  (click)="setButtonText(language.langCode)" [checked]="language.checked" />
              </label>

            </div>
          </form>
        </div>
        <div id="loginCardFooter" class="card-footer">
          <button type="button" class="btn btn-primary gtmSelectLang" (click)="languageSelected()" [innerHTML]="selectLanguage">
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
